import { useLocation } from '@reach/router';
import { useState } from 'react';
import { UserFeedbackQuery } from '../../../gatsby/createPages.types';
import RichText from '@components/RichText/RichText';
import { FeedbackRequest, Separator, StyledButton, Title, Wrapper } from './UserFeedback.styles';

const UserFeedback = ({ feedbackElements }: UserFeedbackQuery) => {
  const { feedback_text, positive_feedback_text, negative_feedback_text, feedback_title } =
    feedbackElements;
  const { pathname } = useLocation();
  const [feedbackType, setFeedbackType] = useState<'like' | 'dislike'>();
  const title = feedback_title.value;
  const createOnClick = (type: 'like' | 'dislike') => () => {
    setFeedbackType(type);
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
    }

    window.dataLayer.push({
      event: 'feedbackSubmitted',
      feedbackSubmittedData: {
        feedback_type: type,
        url: pathname,
      },
    });
  };

  const isFeedbackSubmitted = typeof feedbackType !== 'undefined';

  return (
    <>
      <Separator />
      {!!title && <Title>{title}</Title>}
      <Wrapper>
        {!isFeedbackSubmitted && (
          <FeedbackRequest>
            <RichText {...feedback_text} />
            <StyledButton aria-label="like" onClick={createOnClick('like')}>
              <img src="/images/like.svg" alt="like" />
            </StyledButton>
            <StyledButton aria-label="dislike" onClick={createOnClick('dislike')}>
              <img src="/images/dislike.svg" alt="dislike" />
            </StyledButton>
          </FeedbackRequest>
        )}
        {feedbackType === 'dislike' && <RichText {...negative_feedback_text} />}
        {feedbackType === 'like' && <RichText {...positive_feedback_text} />}
      </Wrapper>
    </>
  );
};

export default UserFeedback;
